import { useEffect, useState } from "react"
import { Alert, Button, Container, MenuItem, Paper, Stack, TextField } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom"
import FormPageHeader from "../../components/FormPageHeader"
import { alojamentoApi, cepBR } from "./api"

const vazio = { nome: "", obra_id: "", cep: "", logradouro: "", numero: "", complemento: "", bairro: "", cidade: "", estado: "", ponto_referencia: "", capacidade_maxima: "", observacoes: "" }

export default function AlojamentoForm() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [form, setForm] = useState(vazio), [obras, setObras] = useState([]), [loading, setLoading] = useState(Boolean(id)), [saving, setSaving] = useState(false), [error, setError] = useState("")

  useEffect(() => {
    let ativo = true
    Promise.all([alojamentoApi("/obras"), id ? alojamentoApi(`/${id}`) : Promise.resolve(null)])
      .then(([listaObras, registro]) => {
        if (!ativo) return
        setObras(listaObras)
        if (registro) setForm({ ...vazio, ...registro, obra_id: String(registro.obra_id), capacidade_maxima: String(registro.capacidade_maxima) })
      }).catch(e => ativo && setError(e.message)).finally(() => ativo && setLoading(false))
    return () => { ativo = false }
  }, [id])

  const mudar = e => setForm(atual => ({ ...atual, [e.target.name]: e.target.value }))
  async function salvar(e) {
    e.preventDefault(); setSaving(true); setError("")
    try {
      await alojamentoApi(id ? `/${id}` : "", id ? "PUT" : "POST", { ...form, obra_id: Number(form.obra_id), capacidade_maxima: Number(form.capacidade_maxima), cep: form.cep.replace(/\D/g, "") })
      navigate(-1)
    } catch (err) { setError(err.message) }
    finally { setSaving(false) }
  }

  return <Container maxWidth="lg" disableGutters>
    <FormPageHeader title={id ? "Editar alojamento" : "Cadastrar alojamento"} subtitle="Vincule o endereço e a capacidade à obra correspondente." />
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    {loading ? <Alert severity="info">Carregando dados do alojamento…</Alert> : <Paper component="form" onSubmit={salvar} sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
      <Stack spacing={2}>
        <TextField required select name="obra_id" label="Obra vinculada" value={form.obra_id} onChange={mudar} disabled={Boolean(id)}>
          <MenuItem value="">Selecione a obra</MenuItem>{obras.map(o => <MenuItem key={o.cod_almoxarifado} value={String(o.cod_almoxarifado)}>{o.nome}</MenuItem>)}
        </TextField>
        <TextField required name="nome" label="Nome ou identificação do alojamento" value={form.nome} onChange={mudar} inputProps={{ maxLength: 150 }} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <TextField required name="cep" label="CEP" value={cepBR(form.cep)} onChange={e => setForm(f => ({ ...f, cep: e.target.value.replace(/\D/g, "").slice(0, 8) }))} inputProps={{ inputMode: "numeric", maxLength: 9 }} />
          <TextField required fullWidth name="logradouro" label="Logradouro" value={form.logradouro} onChange={mudar} />
          <TextField required name="numero" label="Número" value={form.numero} onChange={mudar} />
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <TextField fullWidth name="complemento" label="Complemento" value={form.complemento || ""} onChange={mudar} />
          <TextField required fullWidth name="bairro" label="Bairro" value={form.bairro} onChange={mudar} />
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <TextField required fullWidth name="cidade" label="Cidade" value={form.cidade} onChange={mudar} />
          <TextField required name="estado" label="UF" value={form.estado} onChange={e => setForm(f => ({ ...f, estado: e.target.value.toUpperCase().slice(0, 2) }))} inputProps={{ maxLength: 2 }} />
          <TextField type="number" required name="capacidade_maxima" label="Capacidade máxima" value={form.capacidade_maxima} onChange={mudar} inputProps={{ min: 1, step: 1 }} />
        </Stack>
        <TextField name="ponto_referencia" label="Ponto de referência" value={form.ponto_referencia || ""} onChange={mudar} />
        <TextField name="observacoes" label="Observações" value={form.observacoes || ""} onChange={mudar} multiline minRows={3} />
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={() => navigate(-1)} disabled={saving}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={saving}>{saving ? "Salvando…" : "Salvar alojamento"}</Button>
        </Stack>
      </Stack>
    </Paper>}
  </Container>
}
